import { initTemplatePolyfill } from 'lit-html/polyfills/template_polyfill';

import Product from './product/product';
import { ProductProps } from './product/types/productProps';

// Get template polyfill (only needed on IE).
initTemplatePolyfill();

declare global {
    interface Window {
        BigCommerce: {
            initializeProduct?: (props: ProductProps) => Product;
        };
    }
}

window.BigCommerce = window.BigCommerce || {};
window.BigCommerce.initializeProduct = (props: ProductProps): Product => {
    return new Product(props);
};
